import $ from 'jquery';
import pdfjsLib from 'pdfjs-dist'; 
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';

const pdfJsInitializer = () => {
    pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

    $(document).on('click', '[data-toggle=pdf-preview]', function (e) {
        e.preventDefault();
        e.stopPropagation();
        loadView(e.currentTarget);
        return false;
    });
}

const loadView = (btn) => {
    let currentPageIndex = 0;
    let cursorIndex = Math.floor(currentPageIndex);
    let pdfInstance = null;
    let totalPagesCount = 0;
    let viewport = null;

    const $row = createRow(btn);
    if ($row != null) { //if not already exist
        viewport = $row.find(".viewport")[0];
       
        const loadingTask = pdfjsLib.getDocument(btn.href);
        loadingTask.promise.then(pdf => {
            pdfInstance = pdf;
            totalPagesCount = pdf.numPages;
            initToolbar($row);
            render();
        }).catch(() => {
            $row.find('.viewport').html('<div class="alert alert-warning">Náhled dokumentu se nepodařilo načíst.</div>');
        });
    }

    function onPagerButtonsClick(event) {
        const action = event.target.getAttribute("data-pager");
        if (action === "prev") {
            if (currentPageIndex === 0) {
                return;
            }
            currentPageIndex--;
            if (currentPageIndex < 0) {
                currentPageIndex = 0;
            }
            render();
        }
        if (action === "next") {
            if (currentPageIndex === totalPagesCount - 1) {
                return;
            }
            currentPageIndex++;
            if (currentPageIndex > totalPagesCount - 1) {
                currentPageIndex = totalPagesCount - 1;
            }
            render();
        }
    }

    function onCloseButtonClick() {
        $row.remove();
    }

    function initToolbar($row) {
        const pager = $row.find(".pager")[0];
        const closer = $row.find(".pdf-close")[0];

        pager.addEventListener("click", onPagerButtonsClick);
        closer.addEventListener("click", onCloseButtonClick);

        return () => {
            pager.removeEventListener("click", onPagerButtonsClick);
            closer.removeEventListener("click", onCloseButtonClick);
        };
    }

    function render() {
        cursorIndex = Math.floor(currentPageIndex);
        const startPageIndex = cursorIndex;
        const endPageIndex =
            startPageIndex + 1 < totalPagesCount
                ? startPageIndex
                : totalPagesCount - 1;

        const renderPagesPromises = [];
        for (let i = startPageIndex; i <= endPageIndex; i++) {
            renderPagesPromises.push(pdfInstance.getPage(i + 1));
        }

        Promise.all(renderPagesPromises).then(pages => {
            const pagesHTML = `<div style="width:100%; height:500px;"><canvas></canvas></div>`.repeat(pages.length);
            viewport.innerHTML = pagesHTML;
            pages.forEach(renderPage);
        });
    }

    function renderPage(page) {
        let pdfViewport = page.getViewport({ scale: 1 });

        const container =
            viewport.children[page.pageIndex - cursorIndex];
        pdfViewport = page.getViewport({ scale: container.offsetWidth / pdfViewport.width });
        const canvas = container.children[0];
        const context = canvas.getContext("2d");
        canvas.height = pdfViewport.height;
        canvas.width = pdfViewport.width;

        page.render({
            canvasContext: context,
            viewport: pdfViewport
        });
    }
}

const createRow = (btn) => {
    const $row = $(btn).closest("tr");
    const $viewer = $(`
        <tr class="dt-preview"><td colspan="99"><div class="pdf-viewer">
            <div role="toolbar" class="toolbar">
                <div class="pager"><button type="button" data-pager="prev"></button><button type="button" data-pager="next"></button></div>
                <button type="button" class="pdf-close"></button>
            </div>
        <div class="viewport-container"><div role="main" class="viewport"></div></div></div></td></tr>`);

    if (!$row.next().hasClass("dt-preview")) {
        $row.after($viewer);
        return $viewer;
    }
    else {
        return null;
    }
}



export {
    pdfJsInitializer
}
